import EnquiryForm from "@/components/site/EnquiryForm";

export default function Contact() {
  return (
    <div className="container-x grid gap-12 py-16 lg:grid-cols-12" data-testid="contact-page">
      <div className="lg:col-span-5">
        <p className="eyebrow">Contact</p>
        <h1 className="mt-3 font-display text-4xl font-semibold tracking-tighter text-white sm:text-5xl">Let's talk investments.</h1>
        <p className="mt-6 max-w-md leading-relaxed text-slate-400">
          Questions about a listing, your account, deposits or withdrawals? Send us a message and we'll reply by email.
        </p>
        <ul className="mt-10 space-y-3 text-sm text-slate-300">
          <li>[Business address]</li>
          <li>[Phone number]</li>
          <li>[Contact email]</li>
        </ul>
      </div>
      <div className="lg:col-span-7"><EnquiryForm /></div>
    </div>
  );
}
